import { useState } from "react";
import { TbRuler2 } from "react-icons/tb";

export const useProyectos = (initialForm, validateForm, autusuario, apibig) => {
  /*  Variables de estado */
  const [form, setForm] = useState(initialForm);
  const [errores, setErrores] = useState({});
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);

  /*  Metodos                     */
  /*  Al cambiar                  */
  const handleChange = (e) => {

    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
      };
  const handleClear = (e) => {
    setForm(initialForm) 
  }
  /*  Al perder el foco  */
  const handleBlur = (e) => {
    handleChange(e);
    setErrores(validateForm(form));
  };

  /*  Al hacer submit  */
  const handleSubmit = async (e) => {    
    const envio = form 
    envio.proyecto = autusuario.configuracion.proyecto;         
    e.preventDefault();    
   // try {    
      const proyecto = autusuario.configuracion.proyecto;                                          
      const response = await apibig.post("/api/proyectos/addproyecto", JSON.stringify(form)); 
      handleClear()    
     console.log(form)
   /*  } catch (error) {
      console.error("Error al obtener usuarios:", error);
    } finally {
   
    }*/
  };


  return {
    form,
    errores,
    loading,
    response,
    handleChange,
    handleBlur,
    handleSubmit,
    handleClear
  };
};